import moment from "moment"
import colorArray from "helpers/colorArray"
import { Line } from "react-chartjs-2"

const cumulativeTraffic = (props, state) => {
	try {
		let all = {}
		// Find whether this is island or internal and point to the right set
		if (_.isEmpty(state)) {
			// Widget
			state = {
				island: false,
				endWeek: moment().endOf("isoWeek").unix(),
			}
		}
		let bucket = state.island ? props.payload.traffic : props.payload.exec.weeklyReport.trafficEntries.ytd
		let indiv = _.filter(
			state.island ? bucket.current.entries : bucket.individual,
			(r) => r.traffic_date >= moment().startOf("year").unix() && r.traffic_date <= state.endWeek
		)
		let grouped = _.filter(
			state.island ? bucket.current.grouped.array : bucket.grouped,
			(r) => r.traffic_date >= moment().startOf("year").unix() && r.traffic_date <= state.endWeek
		)
		_.forEach(indiv, (v) => {
			let week = moment.unix(v.traffic_date).isoWeek()
			let year = moment.unix(v.traffic_date).isoWeekYear()
			let property = _.find(props.payload.public.properties, { id: v.property })
			if (!property) {
				return
			}
			let path = `${year}.${week}.${property.id}`
			if (!_.has(all, path)) {
				_.setWith(
					all,
					path,
					{
						individual: 0,
						grouped: 0,
						total: 0,
						builderTraffic: 0,
						welcomeTraffic: 0,
					},
					Object
				)
			}
			all[year][week][property.id].individual++
			all[year][week][property.id].total++
			if (v.welcomeCenter) all[year][week][property.id].welcomeTraffic++
			else all[year][week][property.id].builderTraffic++
		})
		_.forEach(grouped, (v) => {
			let week = moment.unix(v.traffic_date).isoWeek()
			let year = moment.unix(v.traffic_date).isoWeekYear()
			let property = _.find(props.payload.public.properties, { id: v.property })
			if (!property) return
			let path = `${year}.${week}.${property.id}`
			if (!_.has(all, path)) {
				_.setWith(
					all,
					path,
					{
						individual: 0,
						grouped: 0,
						total: 0,
						builderTraffic: 0,
						welcomeTraffic: 0,
					},
					Object
				)
			}
			all[year][week][property.id].grouped += v.prospect_count + v.realtor_count
			all[year][week][property.id].total += v.prospect_count + v.realtor_count
			if (v.welcomeCenter) all[year][week][property.id].welcomeTraffic += v.prospect_count + v.realtor_count
			else all[year][week][property.id].builderTraffic += v.prospect_count + v.realtor_count
		})
		let year = new Date().getFullYear()
		let properties = _.map(props.payload.public.properties, (r) => {
			return { name: r.name, id: r.id }
		})
		let years = [year]
		let store = {}
		_.forEach(properties, (r) => {
			_.forEach(years, (y) => {
				let path = `${r.name} Builder ${y}`
				store[path] = {
					name: r.name,
					id: r.id,
					year: y,
					data: [],
					type: "builder",
				}
				path = `${r.name} Welcome ${y}`
				store[path] = {
					name: r.name,
					id: r.id,
					year: y,
					data: [],
					type: "welcome",
				}
			})
		})
		let curWeek = moment().isoWeek()
		let labels = _.range(1, 53)
		_.forEach(years, (y) => {
			_.forEach(labels, (week) => {
				_.forEach(properties, (c) => {
					let val = _.get(all, `[${y}][${week}].${c.id}`)
					// First builder traffic
					let path = `${c.name} Builder ${y}`
					// for actual sales dont put dots for the future
					if (y == moment().year() && week >= curWeek) return
					if (val && val.builderTraffic) store[path].data.push(val.builderTraffic)
					else store[path].data.push(0)
					// Now welcome traffic
					path = `${c.name} Welcome ${y}`
					// for actual sales dont put dots for the future
					if (y == moment().year() && week > curWeek) return
					if (val && val.welcomeTraffic) store[path].data.push(val.welcomeTraffic)
					else store[path].data.push(0)
				})
			})
		})
		//console.log(store)
		// If viewing current year, chop off the weeks in the future
		let opts = {
			tooltips: {
				enabled: true,
			},
			legend: {
				display: true,
				position: "bottom",
			},
			scales: {
				xAxes: [
					{
						ticks: {
							//beginAtZero: true,
						},
					},
				],
			},
			plugins: {
				datalabels: { display: false },
			},
		}
		let datasets = []
		let i = 0
		_.forEach(store, (v, k) => {
			// Clean out ones with no data
			if (!_.sum(v.data) && !_.sum(v.projectionData)) return
			let bg = colorArray[i]
			/* let lookup = _.find(props.payload.public.properties, { name: v.name })
				if (lookup && lookup.color) bg = lookup.color
				bg = helpers.colorShade(bg, _.random(-20, 20)) */
			datasets.push({
				label: k,
				data: v.data,
				borderColor: bg,
				backgroundColor: bg,
				borderDash: v.year !== moment().year() ? [2, 3] : [0, 0],
				//borderWidth:v.year !== moment().year() ? 1 : 3,
				borderDashOffset: v.year !== moment().year() ? 5 : 0,
				fill: false,
			})
			i++
		})
		const data = {
			labels,
			datasets,
		}
		return (
			<>
				<h3 className="statBox__title mb-2">Weekly Traffic Analysis</h3>
				<Line data={data} options={opts} />
			</>
		)
	} catch (e) {
		console.log(e)
	}
}

export default cumulativeTraffic
